import { FeatureFlag, useFeatureFlag } from "../contexts/launchDarklyContext";

/**
 * Whether the Work Steps surface (sidebar entry, routes, and all work step
 * flows) is enabled for the current workspace. The backend gates /work-steps
 * endpoints on the same `ops-audit-midship-integration` LaunchDarkly flag, so
 * one dashboard toggle turns the feature on or off end to end.
 *
 * Fails closed (off) until flags resolve.
 */
export function useWorkStepsEnabled(): boolean {
  return useFeatureFlag(FeatureFlag.workStepsIntegration);
}
